import type { ReactNode } from 'react';
import { useIsPhone } from '../lib/use-media';

/** Desktop page header (crumb + title + actions). On the phone the title lives in the top bar. */
export function PageHead({
  crumb,
  title,
  actions,
}: {
  crumb?: string;
  title: string;
  actions?: ReactNode;
}) {
  const phone = useIsPhone();
  if (phone)
    return actions ? (
      <div className="row wrap" style={{ gap: 8 }}>
        {actions}
      </div>
    ) : null;
  return (
    <div className="pagehead">
      <div>
        {crumb ? <div className="crumb">{crumb}</div> : null}
        <h1>{title}</h1>
      </div>
      {actions}
    </div>
  );
}
